import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import IndexPage from "../views/index.vue";
import productIndex from "./product/index";
import solutionIndex from "./solution/index";
import ecologyIndex from "./ecology/index";

Vue.use(VueRouter);

// const routes: Array<RouteConfig> = [
//   {
//     path: "/",
//     alias: "/index",//重定向
//     component: IndexPage,
//   },
// 	{
// 		path: '*',//错误地址通配
// 		alias: '/index',
// 		component: IndexPage
// 	},
  // {
  //   path: "/product",
  //   component: () => import("../components/product/product.vue"),
  //   children: [
  //     {
  //       path: "designer",
  //       component: () => import("../components/product/designer/index.vue"),
  //     }
  //   ]
  // },
// ]

const baseRoutes:Array<RouteConfig> = [
    {
    path: "/",
    alias: "/index",//重定向
    component: IndexPage,
    meta: {
      title: '首页'
    }
  },
	{
		path: '*',//错误地址通配
		alias: '/index',
		component: IndexPage,
    meta: {
      title: '首页'
    }
	},
];

const routes = baseRoutes.concat(productIndex, solutionIndex, ecologyIndex);

const router = new VueRouter({
  // mode: "history",
  base: process.env.BASE_URL,
  routes
});

const whiteList = ['/login'];//需要登录能访问

router.beforeEach((to, from, next) => {
  if (to.meta) {
    document.title = '亚信RPA门户网站-' + to.meta.title;
  }
	if (whiteList.indexOf(to.path) == -1) {
    next();
  } else {
    console.log('请先登录')
  }

})

export default router;
